// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bc1d5b47","239":"37ecd169","667":"b7fba64a"}[chunkId] + ".chunk.js";
};